$('.consultation-modal__close').on('click', function() {
    $('.overlay').removeClass('active');
    $('.consultation-modal.active').removeClass('active');
})




// WEBPACK FOOTER //
// ./scripts/components/consultation-modal/init.js